import Recognitions from "./Recognitions";

export default Recognitions;
